/* eslint-disable */
import Vue from "vue";
import Router from "vue-router";
import paths from "./paths";
import store from "@/store";
import UserService from "@/services/UserService";
import { async } from "q";

Vue.use(Router);
const router = new Router({
  base: "/",
  mode: "hash",
  linkActiveClass: "active",
  routes: paths,
});
// router gards
router.beforeEach(async (to, from, next) => {
  let is_login = false;

  if (localStorage._token != undefined && localStorage._token != null && localStorage._token != "" && localStorage._token != "undefined") {
    console.log("localStorage._token "+localStorage._token)
    await UserService.isLogin()
      .then((response) => {
        if (localStorage._company_name != undefined) {
          is_login = true;
        } else {
          is_login = false;
        }
      })
      .catch((err) => {
        is_login = false;
        console.log(err);
      });
  }
  /*console.log("dasa", localStorage.getItem("_is_admin"));
    console.log('this.check :' + this.check)
    if (this.check == undefined || this.check == false) {
        console.log("checkif", this.check)
        localStorage.clear();
        console.log(localStorage.getItem("_is_admin"));
        console.log("_token", _token)
        console.log("_company_guid ", _company_guid)
        this.check = false
    } else {
        console.log("checkelse", this.check)
        this.check = true
    }
*/
  if (to.matched.some((record) => record.meta.requiresAuth) && !is_login) {
    next({
      name: "Login",
    });
  } else {
    if (localStorage._is_admin == undefined) {
      localStorage._is_admin = undefined;
    }
    if (to.meta._is_admin != undefined) {
      let meta_admin = (meta_admin = to.meta._is_admin.toString());
      let local_admin = localStorage._is_admin.toString();
      if (to.redirectedFrom != undefined) {
        if (to.redirectedFrom != "/") {
          if (meta_admin == local_admin) {
            next();
          } else {
            next({
              name: "NotFound",
            });
          }
        } else {
          if (meta_admin == local_admin) {
            next();
          } else {
            if (local_admin == "false") {
              next({
                name: "PageEmployee",
              });
            } else {
              next({
                name: "Login",
              });
            }
          }
        }
      } else {
        if (meta_admin == local_admin) {
          next();
        } else {
          next({
            name: "Login",
          });
        }
      }
      /* if (to.meta._is_admin == localStorage._is_admin) {
                 next()
                 NProgress.start();
             }else{
                 next({
                     name: 'Login'
                 })
             }*/
    } else {
      next();
    }
    /*  if (to.matched.some(record => record.meta._is_admin) == localStorage._is_admin) {
              console.log("admin");
              next()
  
          }
  
          else if (to.matched.some(record => record.meta._is_admin) == !localStorage._is_admin) {
              console.log("Employee");
              next()
          } else {
              next({
                  name: 'Login'
              })
          }*/
  }
});

router.afterEach((data, from) => {
  store.commit("app/changePage", {
    pageName: data.name,
  });
});

export default router;
